export default "__VITE_ASSET__BVU5oA_c__"